import React from "react";
import globalImg from "../../assets/images/webp/global-img.webp";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
import { GLOBAL_LIST } from "../../utils/other-component";
const GolobalWellness = () => {
  return (
    <>
      <div className="bg-[#EAF3EE]">
        <div className="flex items-center justify-between max-w-[1440px] mx-auto max-xl:flex-wrap-reverse max-xl:px-4 max-xl:py-16  max-xl:gap-10">
          <img
            src={globalImg}
            alt="global"
            className="w-full max-w-[629px] pointer-events-none max-xl:mx-auto"
          />
          <div className="w-full max-w-[587px] mx-auto max-xl:max-w-full">
            <BlueHeading lineClassOne="!hidden" text="Global Wellness" />
            <Heading children="What This Collaboration Means for You" />
            <div className="flex items-center flex-col gap-4 mt-10 max-lg:mt-6 max-md:mt-4">
              {GLOBAL_LIST.map((obj, i) => (
                <div
                  key={i}
                  className="rounded-lg bg-white  max-xl:w-full flex  p-4 gap-[11px] items-center h-[138px] max-xl:h-full"
                >
                  <img
                    src={obj.icon}
                    alt="icons"
                    className="w-full max-w-[54px]"
                  />
                  <div className="flex flex-col ">
                    <h4 className="text-[#001A3D] text-lg font-bold leading-[23.98px]">
                      {obj.title}
                    </h4>
                    <p className="text-[#001A3D] text-sm font-normal leading-[150%]">
                      {obj.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GolobalWellness;
